import React, { useEffect, useState } from 'react'
import { Accordion, AccordionToggleEventHandler, makeStyles, tokens } from '@fluentui/react-components'
import { SubscriptionAccordionItem } from './SubscriptionAccordionItem'
import { UseFormReturn } from 'react-hook-form'
import { Components, DemandComplianceModuleDefinition, Modules, RiskManagementModules, SubscriptionAndUsersDTO } from '../../../api/schemas/schema'
import { getModuleType } from '../../../helpers/subscriptionHelper'
import { api } from '../../../helpers/apiHelper'
import { t } from '../../../i18n/i18n'

const useStyles = makeStyles({
   marginBottom: {
      marginBottom: tokens.spacingVerticalM,
   },
})

type ControlledSubscriptionAccordionProps = {
   subscriptionAndUserForm: UseFormReturn<SubscriptionAndUsersDTO, any, SubscriptionAndUsersDTO>
}

export const ControlledSubscriptionAccordion = ({ subscriptionAndUserForm }: ControlledSubscriptionAccordionProps) => {
   const classes = useStyles()
   const { watch } = subscriptionAndUserForm
   const [openItems, setOpenItems] = React.useState<string[]>(['component', 'demandComplianceModuleDefinitionId', 'riskManagementModule'])
   const [demandModules, setDemandModules] = useState<DemandComplianceModuleDefinition[]>([])

   useEffect(() => {
      ;(async () => {
         try {
            const response = await api().getAllDemandModules()
            setDemandModules(response.data || [])
         } catch (error) {
            console.error('Failed to fetch demand modules', error)
         }
      })()
   }, [])

   const demandModuleNames = demandModules.reduce(
      (acc, curr) => {
         if (curr.id) {
            acc[curr.id] = curr.name
         }
         return acc
      },
      {} as Record<string, string>
   )

   const selectedModules: Modules[] = watch('modules') || []
   const componentModules = selectedModules.filter((mod) => getModuleType(mod)?.moduleType === 'component' && mod.isActivated)
   const demandCompliancemodules = selectedModules.filter((mod) => {
      const typeInfo = getModuleType(mod)
      if (typeInfo?.moduleType !== 'demandComplianceModuleDefinitionId') return false
      const definition = demandModules.find((d) => d.id === typeInfo.moduleEnumValue)
      return mod.isActivated && definition?.active
   })
   const riskModules = selectedModules.filter((mod) => getModuleType(mod)?.moduleType === 'riskManagementModule' && mod.isActivated)

   const handleToggle: AccordionToggleEventHandler<string> = (event, data) => {
      setOpenItems(data.openItems)
   }

   return (
      <Accordion collapsible multiple openItems={openItems} onToggle={handleToggle}>
         <SubscriptionAccordionItem
            title={t('BaseModules')}
            enumOptions={Components}
            filteredModules={componentModules}
            value="component"
            className={classes.marginBottom}
         />

         <SubscriptionAccordionItem
            title={t('DemandComplianceModules')}
            enumOptions={demandModuleNames}
            filteredModules={demandCompliancemodules}
            value="demandComplianceModuleDefinitionId"
            className={classes.marginBottom}
         />
         <SubscriptionAccordionItem
            title={t('RiskManagementModules')}
            enumOptions={RiskManagementModules}
            filteredModules={riskModules}
            value="riskManagementModule"
            className={classes.marginBottom}
         />
      </Accordion>
   )
}
